import React from 'react'
import { links } from 'common/helpers'
import cx from 'classnames'

import Link from 'components/ui/Link/Link'

import messages from './messages'
import s from './LoginButton.scss'


const LoginButton = ({ className }) => (
  <Link
    className={cx(s.button, className)}
    title={messages.buttonTitle}
    to={links.login}
    customColor
  />
)


export default LoginButton
